import React, { useEffect } from 'react';

import PropTypes from 'prop-types';

import {
  Switch,
  Route,
  useRouteMatch,
  useParams,
  Redirect,
} from 'react-router-dom';

import Report from '../Report';
import { useDispatch } from 'react-redux';
import {
  clearPortfolioList,
  getAllPortfolio,
} from '../../data/store/portfolio/portfolioActions';
import {getAccount} from '../../data/store/account/accountActions';
import FinancialPlanning from '../FinancialPlanning/FinancialPlanning';
import OrderInstructions from '../OrderInstructions/OrderInstructions';
import Monitoring from '../Monitoring/Monitoring';
import { StepRouter } from '../PortfolioOptimization/StepRouter';
import PortfolioRoute from '../Portfolio/PortfolioRoute';
import ClientSummary from '../Clients/ClientSummary';
import NewPortfolio from '../Clients/NewPortfolio';
import ProfileRouting from './ProfileRouting';
import { PrivateRouterWithProps } from '../../PrivateRouterWithProps';
import { permissions } from '../../config/permissions';
import SuggestedRout from '../SuggestedRoot/SuggestedRoot';
import { getUsersForAdvisor } from '../../data/store/advisors/advisorAction';
import PortfolioComposeRoute from '../Portfolio/PortfolioComposeRoute';

const ClientRouting = ({
  theme,
  setUserId,
  needSave,
  setNeedSave,
  saveAlert,
  setSaveAlert,
  optAlert,
  setOptAlert,
  setOptStart,
}) => {
  const { url } = useRouteMatch();
  const { accountId } = useParams();
  const dispatch = useDispatch();

  const { ADVISER, SUPER_ADMIN } = permissions.roles;

  useEffect(() => {
    if (accountId) {
      dispatch(clearPortfolioList());
      dispatch(getUsersForAdvisor());
      accountId !== 'new' && dispatch(getAllPortfolio(accountId));
      accountId !== 'new' && dispatch(getAccount({ id: accountId }));
      // accountId !== 'new' && dispatch(getFinPlan(accountId));
      setUserId(+accountId);
    } else setUserId(null);

    return () => {
      setUserId(null);
    };
  }, [accountId]);

  return (
    <>
      <Switch>
        <Route path={`${url}/inform`}>
          <ProfileRouting
            userId={accountId}
            setUserId={setUserId}
            needSave={needSave}
            setNeedSave={setNeedSave}
            saveAlert={saveAlert}
            setSaveAlert={setSaveAlert}
          />
        </Route>
        <Route path={`${url}/portfolio`} exact>
          <ClientSummary userId={accountId} theme={theme} />
        </Route>
        <Route path={`${url}/portfolio/create-composite`} exact>
          <NewPortfolio userId={accountId} />
        </Route>
        <Route path={`${url}/new-portfolio`} exact>
          <NewPortfolio userId={accountId} />
        </Route>
        <Route path={`${url}/portfolio/composite/:portfolioId`}>
          <PortfolioComposeRoute
            userId={accountId}
            needSave={needSave}
            setNeedSave={setNeedSave}
            saveAlert={saveAlert}
            setSaveAlert={setSaveAlert}
            theme={theme}
          />
        </Route>
        <Route path={`${url}/portfolio/:portfolioId`}>
          <PortfolioRoute
            userId={accountId}
            needSave={needSave}
            setNeedSave={setNeedSave}
            saveAlert={saveAlert}
            setSaveAlert={setSaveAlert}
          />
        </Route>
        <Route path={`${url}/optimization/:portfolioId`}>
          <StepRouter
            userId={accountId}
            optAlert={optAlert}
            setOptAlert={setOptAlert}
            setOptStart={setOptStart}
          />
        </Route>
        <Route exact path={`${url}/order-instructions`}>
          <OrderInstructions userId={accountId} />
        </Route>
        <Route exact path={`${url}/monitoring`}>
          <Monitoring id={accountId} />
        </Route>
        <Route path={`${url}/lifetiming`}>
          <FinancialPlanning userId={accountId} />
        </Route>
        <Route exact path={`${url}/documents`}>
          <Report userId={accountId} />
        </Route>
        <Route exact path={`${url}/suggested-portfolios`}>
          <Redirect to={`${url}/suggested-portfolios/suggestions`} />
        </Route>
        <PrivateRouterWithProps
          path={`${url}/suggested-portfolios/:typeTab`}
          roles={[ADVISER, SUPER_ADMIN]}
          customProps={{ userId: accountId }}
          component={SuggestedRout}
        />
      </Switch>
    </>
  );
};

export default ClientRouting;

ClientRouting.propTypes = {
  theme: PropTypes.string,
  userId: PropTypes.string,
  setUserId: PropTypes.func,
  needSave: PropTypes.bool,
  setNeedSave: PropTypes.func,
  saveAlert: PropTypes.object,
  optAlert: PropTypes.object,
  setSaveAlert: PropTypes.func,
  setOptAlert: PropTypes.func,
  setOptStart: PropTypes.func,
};
